
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/embedded",
      function () {
        return require("private-next-pages/auth/embedded.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/embedded"])
      });
    }
  